import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useVideos, toYouTubeEmbed, toYouTubeThumb } from '../../hooks/useVideos';

const VideoTiles = () => {
  const { videos, loaded } = useVideos();
  const [openIdx, setOpenIdx] = useState(-1);

  useEffect(() => {
    if (openIdx < 0) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpenIdx(-1); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [openIdx]);

  if (!loaded || !videos || videos.length === 0) return null;

  const open = openIdx >= 0 && openIdx < videos.length ? videos[openIdx] : null;

  const modal = open ? createPortal(
    <div className="video-modal-overlay" onClick={() => setOpenIdx(-1)}>
      <div className="video-modal" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal-close" onClick={() => setOpenIdx(-1)} aria-label="Close" type="button">×</button>
        <div className="video-modal-frame">
          <iframe
            src={toYouTubeEmbed(open.url) + '?autoplay=1&rel=0'}
            title={open.title || 'Video'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        {open.title && <div className="video-modal-caption">{open.title}</div>}
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <div className="video-tiles-wrap">
        <div className="video-tiles-head">
          <span className="vth-dot" />
          <span className="vth-label">Watch — Latest Videos</span>
        </div>
        <div className="video-tiles-grid">
          {videos.map((v, i) => {
            const thumb = toYouTubeThumb(v.url);
            return (
              <button
                key={i}
                className="video-tile"
                onClick={() => setOpenIdx(i)}
                aria-label={v.title || 'Play video'}
                type="button"
              >
                {thumb ? (
                  <img src={thumb} alt="" />
                ) : (
                  <div className="video-tile-placeholder">▶</div>
                )}
                <div className="video-tile-play">▶</div>
                {v.title && <div className="video-tile-title">{v.title}</div>}
              </button>
            );
          })}
        </div>
      </div>
      {modal}
    </>
  );
};

export default VideoTiles;
